module.exports = __webpack_public_path__ + "static/trip-d1682f27058e770eb9621737cd5f79d2.png";